import {useMutation, useQueryClient} from '@tanstack/react-query';
import shipmentUpdaters from '@/api/updaters/shipments';
import {CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY} from '@/hooks/queries/use-campaign-v2-creators-counts-query';

function useShipShipment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['shipments', 'ship'],
    mutationFn: shipmentUpdaters.ship,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({
        queryKey: [CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY],
      });
    },
  });
}

export default useShipShipment;
